import styled from 'styled-components';
import { device } from '../../const/device';

const Logo = styled.div<{ themeColor: string}>`
  box-sizing: border-box;
  background-position: center;
  background-size: contain;
  background-image: url(${process.env.REACT_APP_PATH}icons/logo-${props => props.themeColor == "black"?'black':'white'}.svg);
  width: 56px;
  height: 24px;
  z-index:200;
  margin-top: -16px;
  background-repeat: no-repeat;
  
  @media(${device.tablet}){
    margin-top: 0;
  }
  
  @media (${device.mobileL}) {
    width: 38px;
    height: 16px;
    position: relative;
    z-index: 200;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export default Logo;
